/**
 * 通过 UserAgent 判断当前是否在微信中
 * @returns {boolean}
 */
export const isWechat = () => !!window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i);

/**
 * 判断是否为 iOS 版本微信
 * @returns {boolean}
 */
export const isWechat_iOS = () => !!window.__wxjs_is_wkwebview;

/**
 * 判断是否为 Android 版本微信
 * @returns {boolean}
 */
export const isWechat_Android = () => !isWechat_iOS();
